/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : hightman (hightman@cloud-sun.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { Message, MessageContact, MessagePost } from './types/message';

export const getMessages = (xid: string, point?: number) => http.get<Message[]>(`messages/u-${xid}`, { point });
export const postMessage = (xid, data) => http.post<MessagePost>(`messages/u-${xid}`, data);
export const delMessage = (id) => http.delete(`messages/${id}`);
export const getMessageContacts = () => http.get<MessageContact[]>('messages/contacts');
